// The reqst/cookie-bar block collects the choice and writes this cookie; the
// analytics block replays it inline in <head>. This module replays it again
// once the bundle runs, and owns the two exclusions the inline block cannot
// know about: "Do Not Track" and a logged-in editor (admin bar).
const COOKIE = 'reqst_cookieconsent';

const AXES = [ 'ad_storage', 'ad_user_data', 'ad_personalization', 'analytics_storage' ];

function readConsent() {
	const found = document.cookie
		.split( '; ' )
		.find( ( c ) => c.startsWith( COOKIE + '=' ) );
	if ( ! found ) {
		return null;
	}
	try {
		return JSON.parse( decodeURIComponent( found.split( '=' ).slice( 1 ).join( '=' ) ) );
	} catch {
		return null;
	}
}

function isExcluded() {
	const dnt = navigator.doNotTrack || window.doNotTrack;
	return 'yes' === dnt || '1' === dnt || null !== document.querySelector( '#wpadminbar' );
}

export function main() {
	window.dataLayer = window.dataLayer || [];
	if ( 'function' !== typeof window.gtag ) {
		window.gtag = function () {
			// eslint-disable-next-line prefer-rest-params
			window.dataLayer.push( arguments );
		};
	}

	if ( isExcluded() ) {
		window.gtag( 'consent', 'update', Object.fromEntries( AXES.map( ( a ) => [ a, 'denied' ] ) ) );
		return false;
	}

	// No stored choice means the inline default already says it all. Pushing
	// "denied" here would also override a choice made moments ago on this page.
	const stored = readConsent();
	if ( ! stored ) {
		return false;
	}

	window.gtag(
		'consent',
		'update',
		Object.fromEntries( AXES.map( ( a ) => [ a, 'granted' === stored[ a ] ? 'granted' : 'denied' ] ) )
	);
	return true;
}
